import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  textField: {
    width: '100%'
  }
}));
